import './App.css';
import {
  HashRouter as Router,
  Route,
  Link,
} from "react-router-dom";

import Navbar from "./components/Navbar";
import Home from "./contents/Home";
import Education from './contents/Education';
import Contact from './contents/Contact';
import Project from './contents/Project';


function App() {
  return(
    <Router basename="/portfolio">
      <div className="App">
        <Navbar />
        <Route exact path="/"> <Home/> </Route>
        <Route path="/education"> <Education /> </Route>
        <Route path="/contact"> <Contact /> </Route>
        <Route path="/projects"> <Project /> </Route>
      </div>
    </Router>
    
  )
}


export default App;
